export const NOTIFICATIONS_CLEAR_MARK_AS_READ_QUEUE = 'NOTIFICATIONS_CLEAR_MARK_AS_READ_QUEUE'
export const NOTIFICATIONS_REMOVE_NOTIFICATION = 'NOTIFICATIONS_REMOVE_NOTIFICATION'
export const NOTIFICATIONS_SET_MARK_AS_READ_QUEUE = 'NOTIFICATIONS_SET_MARK_AS_READ_QUEUE'
export const NOTIFICATIONS_SET_NEW_NOTIFICATION_COUNT = 'NOTIFICATIONS_SET_NEW_NOTIFICATION_COUNT'
export const NOTIFICATIONS_SET_NOTIFICATIONS = 'NOTIFICATIONS_SET_NOTIFICATIONS'
export const NOTIFICATIONS_SET_NOTIFICATIONS_VISIBILITY = 'NOTIFICATIONS_SET_NOTIFICATIONS_VISIBILITY'
